import React from "react";

import { Authenticator } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";
import { Amplify } from "aws-amplify";
import "bootstrap/dist/css/bootstrap.min.css";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { RecoilRoot } from "recoil";

import { ApolloProviderWithErrorHandling } from "./ApolloProviderWithErrorHandling";
import { App } from "./App";
import { ErrorModal } from "./components/ErrorModal";
import { amplifyConfig } from "./config/amplify";
import { AuthenticationContextProvider } from "./context/authentication";
import { ErrorContextProvider } from "./context/error";

import "./index.scss";

if (!Amplify.getConfig().Auth) {
  Amplify.configure(amplifyConfig.external);
}

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Authenticator.Provider>
        <AuthenticationContextProvider>
          <ErrorContextProvider>
            <ErrorModal />
            <ApolloProviderWithErrorHandling>
              <RecoilRoot>
                <App />
              </RecoilRoot>
            </ApolloProviderWithErrorHandling>
          </ErrorContextProvider>
        </AuthenticationContextProvider>
      </Authenticator.Provider>
    </BrowserRouter>
  </React.StrictMode>,
);
